module.exports = __webpack_public_path__ + "static/img/t20.a6c9336d.png";